import { ScrollingModule } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';

import { ExportMessage, ExportMessageSeverity } from '../../models';

@Component({
  selector: 'mpcm-export-item-messages',
  templateUrl: './export-item-messages.component.html',
  styleUrl: './export-item-messages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScrollingModule],
})
export class ExportItemMessagesComponent {
  readonly messages: InputSignal<ExportMessage[]> = input.required<ExportMessage[]>();

  protected readonly listHeight: Signal<string> = computed(() => this.getListHeight());

  readonly ExportMessageSeverity = ExportMessageSeverity;

  readonly ITEM_SIZE: number = 30;
  private readonly MAX_ELEMENTS_VISIBLE = 5;

  private getListHeight(): string {
    const height: number = Math.min(this.messages().length, this.MAX_ELEMENTS_VISIBLE) * this.ITEM_SIZE;
    return `${height}px`;
  }

  trackByFn(index: number): number {
    return index;
  }
}
